import React from 'react';

const sizeClasses = {
  tiny: 'px-2 py-2 text-xs min-w-[48px] h-[48px]',
  small: 'px-2 py-1 text-xs min-w-[60px]',
  medium: 'px-4 py-2 text-sm min-w-[80px]',
  large: 'px-6 py-3 text-base min-w-[120px]',
};

const colorVariants = {
  green: {
    base: 'bg-gradient-to-b from-green-500 to-green-700 border-t-green-400 border-b-green-800',
    hover: 'hover:from-green-400 hover:to-green-600',
    active: 'shadow-[0_0_20px_rgba(34,197,94,0.8)] shadow-inner',
    text: 'text-white',
  },
  red: {
    base: 'bg-gradient-to-b from-red-500 to-red-700 border-t-red-400 border-b-red-800',
    hover: 'hover:from-red-400 hover:to-red-600',
    active: 'shadow-[0_0_20px_rgba(239,68,68,0.8)] shadow-inner',
    text: 'text-white',
  },
  yellow: {
    base: 'bg-gradient-to-b from-yellow-500 to-yellow-700 border-t-yellow-400 border-b-yellow-800',
    hover: 'hover:from-yellow-400 hover:to-yellow-600',
    active: 'shadow-[0_0_20px_rgba(234,179,8,0.8)] shadow-inner',
    text: 'text-white',
  },
  blue: {
    base: 'bg-gradient-to-b from-blue-500 to-blue-700 border-t-blue-400 border-b-blue-800',
    hover: 'hover:from-blue-400 hover:to-blue-600',
    active: 'shadow-[0_0_20px_rgba(59,130,246,0.8)] shadow-inner',
    text: 'text-white',
  },
  gray: {
    base: 'bg-gradient-to-b from-gray-600 to-gray-800 border-t-gray-500 border-b-gray-900',
    hover: 'hover:from-gray-500 hover:to-gray-700',
    active: 'shadow-[0_0_20px_rgba(156,163,175,0.8)] shadow-inner',
    text: 'text-white',
  },
  amber: {
    base: 'bg-gradient-to-b from-amber-500 to-amber-700 border-t-amber-400 border-b-amber-800',
    hover: 'hover:from-amber-400 hover:to-amber-600',
    active: 'shadow-[0_0_20px_rgba(245,158,11,0.8)] shadow-inner',
    text: 'text-white',
  },
};

export const PhysicalButton = ({
  children,
  onClick,
  color = 'gray',
  size = 'medium',
  active = false,
  disabled = false,
  className = '',
}) => {
  const variant = colorVariants[color] || colorVariants.gray;
  const sizeClass = sizeClasses[size] || sizeClasses.medium;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        ${sizeClass}
        ${variant.base}
        ${variant.text}
        ${!disabled && variant.hover}
        ${active ? variant.active : ''}
        border-2 border-l-0 border-r-0
        rounded-md
        font-bold
        uppercase
        tracking-wide
        shadow-[0_4px_6px_rgba(0,0,0,0.4)]
        transition-all
        duration-150
        ${active ? 'translate-y-1' : ''}
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer active:translate-y-1'}
        ${className}
      `}
    >
      {children}
    </button>
  );
};
